export default __webpack_public_path__ + "static/media/img-0307-brazil-half-face.30da7602.png";